
import React, { useEffect, useState } from 'react';
import { Table, Typography, Spin, Alert, Button, Modal, Input, Select, Popconfirm, message } from 'antd';
import axios from 'axios';
import { baseUrl_SPB } from '../../BaseUrl';
import { useAuth } from '../../AuthProvider';

const { Title } = Typography;


const accountNumbers = [
  'Asset', 'Liability', 'Equity', 'Revenue', 'Expense', 'Other'
];

const ChartOfAccountsPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [id, setId] = useState('');
  const [accountName, setAccountName] = useState('');
  const [accountType, setAccountType] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [inputError, setInputError] = useState('');
  const auth = useAuth();

  const fetchCoA = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${baseUrl_SPB}/api/v1/accounting/coa/list`, {
        headers: { 'Authorization': 'Bearer ' + auth.token }
      });
      setData(response.data);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoA();
    // eslint-disable-next-line
  }, []);

  const handleAdd = () => {
    setEditing(null);
    setId('');
    setAccountName('');
    setAccountNumber('');
    setAccountType('CUSTOM');
    setInputError('');
    setModalOpen(true);
  };

  const handleEdit = (record) => {
    setEditing(record);
    setId(record.id);
    setAccountName(record.accountName);
    setAccountNumber(record.accountNumber || '');
    setAccountType(record.accountType);
    setInputError('');
    setModalOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseUrl_SPB}/api/v1/accounting/coa/${id}`, {
        headers: { 'Authorization': 'Bearer ' + auth.token }
      });
      message.success('Account deleted');
      fetchCoA();
    } catch (e) {
      message.error('Delete failed');
    }
  };

  const handleModalOk = async () => {
    if (!accountName.trim() || !accountType) {
      setInputError('Both fields are required.');
      return;
    }
    setInputError('');
    try {
      // Get companyId from user context (auth.additionalUserInfo)
      const companyId = auth?.additionalUserInfo?.companyId || auth?.additionalUserInfo?.company?.companyId || '';
      const values = { id: id ? id : null, accountName: accountName.trim(), accountType, accountNumber: accountNumber.trim(), companyId };
      if (editing) {
        await axios.post(`${baseUrl_SPB}/api/v1/accounting/coa/add`, values, {
          headers: { 'Authorization': 'Bearer ' + auth.token }
        });
        message.success('Account updated');
      } else {
        await axios.post(`${baseUrl_SPB}/api/v1/accounting/coa/add`, values, {
          headers: { 'Authorization': 'Bearer ' + auth.token }
        });
        message.success('Account added');
      }
      setModalOpen(false);
      fetchCoA();
    } catch (e) {
      message.error('Save failed');
    }
  };

  const handleModalCancel = () => {
    setModalOpen(false);
    setInputError('');
  };

  const columns = [
    { title: 'Account number', dataIndex: 'accountNumber', key: 'accountNumber' },
    { title: 'Account Name', dataIndex: 'accountName', key: 'accountName' },
    { title: 'Account Type', dataIndex: 'accountType', key: 'accountType' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <span>
          {record.isReadOnly==='Y' ? null : <Button size="small" onClick={() => handleEdit(record)} style={{ marginRight: 8 }}>Edit</Button>}
          {record.isReadOnly==='Y' ? null : <Popconfirm title="Delete this account?" onConfirm={() => handleDelete(record.id)} okText="Yes" cancelText="No">
            <Button size="small" danger>Delete</Button>
          </Popconfirm>}
        </span>
      )
    }
  ];

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
      <Title level={2}>Chart of Accounts</Title>
      <Button type="primary" onClick={handleAdd} style={{ marginBottom: 16 }}>Add Account</Button>
      {loading ? <Spin /> : error ? <Alert type="error" message="Failed to load Chart of Accounts" /> :
        <Table columns={columns} dataSource={data} rowKey="id" pagination={true} />}
      <Modal
        open={modalOpen}
        title={editing ? 'Edit Account' : 'Add Account'}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="Save"
        destroyOnClose
      >
        <div style={{ marginBottom: 12 }}>
          <label>Account Name</label>
          <Input value={accountName} onChange={e => setAccountName(e.target.value)} autoFocus />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>Account Number</label>
          <Select
            style={{ width: '100%' }}
            value={accountNumber}
            onChange={setAccountNumber}
            options={accountNumbers.map(t => ({ label: t, value: t }))}
            placeholder="Select type"
          />
        </div>
               {inputError && <div style={{ color: 'red', marginBottom: 8 }}>{inputError}</div>}
      </Modal>
    </div>
  );
};

export default ChartOfAccountsPage;
